import script from "./SendNotificationSubpage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SendNotificationSubpage.vue?vue&type=script&setup=true&lang=ts"

import "./SendNotificationSubpage.vue?vue&type=style&index=0&id=7eed94cc&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eed94cc"]])

export default __exports__